import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, trackByValue } from '@y42/angular/util';
import { DataTestType, RowDriftTestForm } from '@y42/data-test';
import { startWith } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { DataTestBuilderFormService } from '../../data-test-builder-form.service';

interface ThresholdTypeUIModel {
  type: RowDriftTestForm['row_change']['threshold_type'];
  label: 'Relative' | 'Absolute';
}

@UntilDestroy()
@Component({
  selector: 'y42-row-drift-test',
  templateUrl: './row-drift-test.component.html',
  styleUrls: ['./row-drift-test.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowDriftTestComponent {
  constructor(private readonly dataTestBuilderFormService: DataTestBuilderFormService) {}

  readonly thresholdTypes: ThresholdTypeUIModel[] = [
    { type: 'relative', label: 'Relative' },
    {
      type: 'absolute',
      label: 'Absolute',
    },
  ];

  readonly formGroup = this.dataTestBuilderFormService.getFormByTestType(DataTestType.NumRowDrift);

  readonly trackByValue = trackByValue;

  readonly state = connectState(this, {
    isRelative: this.formGroup.controls.threshold_type.valueChanges.pipe(
      startWith(this.formGroup.controls.threshold_type.value),
      map((value) => value === 'relative'),
      tap(() => {
        this.formGroup.controls.lower_threshold.updateValueAndValidity();
        this.formGroup.controls.upper_threshold.updateValueAndValidity();
      }),
    ),
  });
}
